import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionProfileService extends BaseProvider{
	showManagement: boolean=false;
	itemToEdit: any = {};
	
	constructor(
		public globals: GlobalsService,
		public http: HttpClient,		
		public ls: LsHelperService,
	) { 
		super();

		this.baseUrl = "profile";		
	}	

	getByUserProcessId(id) {
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/transaction/' + id;

			var loginData = this.ls.get('loginData');

			this.http.get(
				this.url
			)
			.subscribe(
				(data: any) => {
					this.itemToEdit = data.Data;

				resolve(this.itemToEdit);
			},
			err => {reject(err)}
			);
		});
	}	
}
